import React, { useEffect, useState, Component } from 'react';
import { Card } from '../components/ui/Card';
export const CloudERPImplementation = () => {
  return <div className="space-y-6" data-id="element-158">
      <div data-id="element-159">
        <h1 className="text-2xl font-bold text-gray-900" data-id="element-160">
          Cloud ERP Implementation Guide
        </h1>
        <p className="mt-1 text-sm text-gray-500" data-id="element-161">
          How to implement a low-cost College ERP using cloud office tools
        </p>
      </div>
      {/* Architecture Overview */}
      <Card title="System Architecture" data-id="element-162">
        <div className="space-y-4" data-id="element-163">
          <div className="p-4 bg-blue-50 rounded-lg border border-blue-100" data-id="element-164">
            <h3 className="font-medium text-blue-800 mb-2" data-id="element-165">
              Hybrid Architecture
            </h3>
            <p className="text-sm text-gray-700" data-id="element-166">
              This implementation uses a hybrid approach: React frontend
              (current app) for user interface and cloud tools (Google
              Workspace/Microsoft 365) for data storage and processing.
            </p>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4 mt-4" data-id="element-167">
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-168">
              <h3 className="font-medium text-gray-800 mb-2" data-id="element-169">
                Frontend Components
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1" data-id="element-170">
                <li data-id="element-171">React dashboard (existing)</li>
                <li data-id="element-172">Module interfaces (Admissions, Fees, etc.)</li>
                <li data-id="element-173">Authentication integration</li>
                <li data-id="element-174">Data visualization</li>
              </ul>
            </div>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-175">
              <h3 className="font-medium text-gray-800 mb-2" data-id="element-176">
                Backend Services
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1" data-id="element-177">
                <li data-id="element-178">Google Sheets/Excel Online (central database)</li>
                <li data-id="element-179">Google Forms/Microsoft Forms (data collection)</li>
                <li data-id="element-180">Apps Script/Power Automate (automation)</li>
                <li data-id="element-181">Google Drive/OneDrive (document storage)</li>
              </ul>
            </div>
          </div>
          <div className="mt-4" data-id="element-182">
            <h3 className="font-medium text-gray-800 mb-2" data-id="element-183">Data Flow</h3>
            <div className="flex flex-col md:flex-row justify-between items-center" data-id="element-184">
              <div className="bg-indigo-50 rounded-lg p-3 text-center w-full md:w-1/4" data-id="element-185">
                <p className="text-sm font-medium text-indigo-700" data-id="element-186">Forms</p>
                <p className="text-xs text-gray-500" data-id="element-187">Data Collection</p>
              </div>
              <div className="hidden md:block text-gray-400" data-id="element-188">→</div>
              <div className="bg-indigo-50 rounded-lg p-3 text-center mt-2 md:mt-0 w-full md:w-1/4" data-id="element-189">
                <p className="text-sm font-medium text-indigo-700" data-id="element-190">
                  Spreadsheets
                </p>
                <p className="text-xs text-gray-500" data-id="element-191">Central Database</p>
              </div>
              <div className="hidden md:block text-gray-400" data-id="element-192">→</div>
              <div className="bg-indigo-50 rounded-lg p-3 text-center mt-2 md:mt-0 w-full md:w-1/4" data-id="element-193">
                <p className="text-sm font-medium text-indigo-700" data-id="element-194">React App</p>
                <p className="text-xs text-gray-500" data-id="element-195">Visualization</p>
              </div>
            </div>
          </div>
        </div>
      </Card>
      {/* Module Implementation */}
      <Card title="Module Implementation" data-id="element-196">
        <div className="space-y-6" data-id="element-197">
          {/* Admissions Module */}
          <div className="border-b border-gray-200 pb-4" data-id="element-198">
            <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-199">
              1. Admissions Module
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-200">
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-201">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-202">
                  Data Collection
                </h4>
                <p className="text-sm text-gray-600" data-id="element-203">
                  <span className="font-medium" data-id="element-204">Tool:</span> Google Forms /
                  Microsoft Forms
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-205">
                  <li data-id="element-206">Create comprehensive admission form</li>
                  <li data-id="element-207">Include all required student fields</li>
                  <li data-id="element-208">Add file upload for documents</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-209">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-210">
                  Data Processing
                </h4>
                <p className="text-sm text-gray-600" data-id="element-211">
                  <span className="font-medium" data-id="element-212">Tool:</span> Apps Script / Power
                  Automate
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-213">
                  <li data-id="element-214">Generate unique student IDs</li>
                  <li data-id="element-215">Validate submission data</li>
                  <li data-id="element-216">Send confirmation emails</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-217">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-218">Data Storage</h4>
                <p className="text-sm text-gray-600" data-id="element-219">
                  <span className="font-medium" data-id="element-220">Tool:</span> Google Sheets /
                  Excel Online
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-221">
                  <li data-id="element-222">Student master database</li>
                  <li data-id="element-223">Status tracking columns</li>
                  <li data-id="element-224">Document reference links</li>
                </ul>
              </div>
            </div>
            <div className="mt-3 bg-yellow-50 p-3 rounded-lg" data-id="element-225">
              <h4 className="text-sm font-medium text-yellow-800" data-id="element-226">
                Implementation Script (Google Apps Script)
              </h4>
              <pre className="text-xs bg-gray-800 text-gray-100 p-2 rounded mt-2 overflow-x-auto" data-id="element-227">
                {`function onFormSubmit(e) {
  // Get form response
  var response = e.response.getItemResponses();
  var sheet = SpreadsheetApp.openById('YOUR_SHEET_ID').getSheetByName('Students');
  // Generate unique ID
  var lastRow = sheet.getLastRow();
  var newID = 'ST' + new Date().getFullYear() + (lastRow + 1).toString().padStart(3, '0');
  // Extract data
  var name = response[0].getResponse();
  var email = response[1].getResponse();
  // Add more fields as needed
  // Add to spreadsheet
  sheet.appendRow([newID, name, email, new Date(), 'Pending Review']);
  // Send confirmation email
  MailApp.sendEmail({
    to: email,
    subject: "Application Received - " + newID,
    body: "Dear " + name + ",\\n\\nYour application has been received. Your application ID is " + newID + ".\\n\\nRegards,\\nCollege Admissions"
  });
}`}
              </pre>
            </div>
          </div>
          {/* Fee Collection Module */}
          <div className="border-b border-gray-200 pb-4" data-id="element-228">
            <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-229">
              2. Fee Collection Module
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-230">
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-231">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-232">
                  Payment Collection
                </h4>
                <p className="text-sm text-gray-600" data-id="element-233">
                  <span className="font-medium" data-id="element-234">Tool:</span> Google Forms +
                  Payment Gateway
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-235">
                  <li data-id="element-236">Fee submission form with student ID</li>
                  <li data-id="element-237">Payment integration (Razorpay/Stripe)</li>
                  <li data-id="element-238">Receipt number generation</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-239">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-240">
                  Receipt Generation
                </h4>
                <p className="text-sm text-gray-600" data-id="element-241">
                  <span className="font-medium" data-id="element-242">Tool:</span> Apps Script +
                  Google Docs
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-243">
                  <li data-id="element-244">Template-based receipt generation</li>
                  <li data-id="element-245">PDF conversion and email delivery</li>
                  <li data-id="element-246">Digital signature application</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-247">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-248">
                  Financial Tracking
                </h4>
                <p className="text-sm text-gray-600" data-id="element-249">
                  <span className="font-medium" data-id="element-250">Tool:</span> Google Sheets with
                  formulas
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-251">
                  <li data-id="element-252">Payment status tracking</li>
                  <li data-id="element-253">Due date reminders</li>
                  <li data-id="element-254">Financial dashboards</li>
                </ul>
              </div>
            </div>
            <div className="mt-3 bg-yellow-50 p-3 rounded-lg" data-id="element-255">
              <h4 className="text-sm font-medium text-yellow-800" data-id="element-256">
                Receipt Generation Script
              </h4>
              <pre className="text-xs bg-gray-800 text-gray-100 p-2 rounded mt-2 overflow-x-auto" data-id="element-257">
                {`function generateReceipt(paymentData) {
  // Open receipt template
  var docTemplate = DriveApp.getFileById('YOUR_TEMPLATE_ID');
  var docName = "Receipt-" + paymentData.receiptNumber;
  // Create a copy of the template
  var docCopy = docTemplate.makeCopy(docName);
  var doc = DocumentApp.openById(docCopy.getId());
  var body = doc.getBody();
  // Fill in the template
  body.replaceText('{{RECEIPT_NO}}', paymentData.receiptNumber);
  body.replaceText('{{STUDENT_NAME}}', paymentData.name);
  body.replaceText('{{STUDENT_ID}}', paymentData.studentId);
  body.replaceText('{{AMOUNT}}', paymentData.amount);
  body.replaceText('{{DATE}}', new Date().toLocaleDateString());
  body.replaceText('{{PAYMENT_MODE}}', paymentData.paymentMode);
  // Save and close the document
  doc.saveAndClose();
  // Convert to PDF
  var pdf = DriveApp.getFileById(docCopy.getId()).getAs('application/pdf');
  // Optional: Email the receipt
  MailApp.sendEmail({
    to: paymentData.email,
    subject: "Payment Receipt - " + paymentData.receiptNumber,
    body: "Please find attached your payment receipt.",
    attachments: [pdf]
  });
  return pdf;
}`}
              </pre>
            </div>
          </div>
          {/* Hostel Allocation Module */}
          <div className="border-b border-gray-200 pb-4" data-id="element-258">
            <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-259">
              3. Hostel Allocation Module
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-260">
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-261">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-262">
                  Room Database
                </h4>
                <p className="text-sm text-gray-600" data-id="element-263">
                  <span className="font-medium" data-id="element-264">Tool:</span> Google Sheets /
                  Excel Online
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-265">
                  <li data-id="element-266">Room inventory by hostel/block</li>
                  <li data-id="element-267">Status tracking (available/occupied)</li>
                  <li data-id="element-268">Occupancy history</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-269">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-270">
                  Allocation System
                </h4>
                <p className="text-sm text-gray-600" data-id="element-271">
                  <span className="font-medium" data-id="element-272">Tool:</span> Google Forms + Apps
                  Script
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-273">
                  <li data-id="element-274">Room selection based on availability</li>
                  <li data-id="element-275">Double-booking prevention</li>
                  <li data-id="element-276">Automatic status updates</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-277">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-278">
                  Occupancy Visualization
                </h4>
                <p className="text-sm text-gray-600" data-id="element-279">
                  <span className="font-medium" data-id="element-280">Tool:</span> Google Data Studio
                  / Power BI
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-281">
                  <li data-id="element-282">Real-time occupancy dashboards</li>
                  <li data-id="element-283">Block-wise availability charts</li>
                  <li data-id="element-284">Vacancy forecasting</li>
                </ul>
              </div>
            </div>
            <div className="mt-3 bg-yellow-50 p-3 rounded-lg" data-id="element-285">
              <h4 className="text-sm font-medium text-yellow-800" data-id="element-286">
                Room Allocation Script
              </h4>
              <pre className="text-xs bg-gray-800 text-gray-100 p-2 rounded mt-2 overflow-x-auto" data-id="element-287">
                {`function allocateRoom(studentId, hostelBlock, roomType) {
  var hostelSheet = SpreadsheetApp.openById('YOUR_SHEET_ID').getSheetByName('HostelRooms');
  // Find available rooms matching criteria
  var roomData = hostelSheet.getDataRange().getValues();
  var availableRooms = [];
  for (var i = 1; i < roomData.length; i++) {
    if (roomData[i][1] == hostelBlock && 
        roomData[i][2] == roomType && 
        roomData[i][4] == "Available") {
      availableRooms.push({
        roomId: roomData[i][0],
        row: i + 1
      });
    }
  }
  if (availableRooms.length == 0) {
    return {success: false, message: "No available rooms matching criteria"};
  }
  // Allocate first available room
  var selectedRoom = availableRooms[0];
  // Update room status
  hostelSheet.getRange(selectedRoom.row, 5).setValue("Occupied");
  hostelSheet.getRange(selectedRoom.row, 6).setValue(studentId);
  hostelSheet.getRange(selectedRoom.row, 7).setValue(new Date());
  // Update student record
  var studentSheet = SpreadsheetApp.openById('YOUR_SHEET_ID').getSheetByName('Students');
  var studentData = studentSheet.getDataRange().getValues();
  for (var i = 1; i < studentData.length; i++) {
    if (studentData[i][0] == studentId) {
      studentSheet.getRange(i + 1, 8).setValue(selectedRoom.roomId); // Assuming column H tracks hostel room
      break;
    }
  }
  return {
    success: true, 
    roomId: selectedRoom.roomId,
    message: "Room allocated successfully"
  };
}`}
              </pre>
            </div>
          </div>
          {/* Examination Module */}
          <div className="border-b border-gray-200 pb-4" data-id="element-288">
            <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-289">
              4. Examination Module
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-3 gap-4" data-id="element-290">
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-291">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-292">
                  Grade Recording
                </h4>
                <p className="text-sm text-gray-600" data-id="element-293">
                  <span className="font-medium" data-id="element-294">Tool:</span> Google Forms /
                  Excel Forms
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-295">
                  <li data-id="element-296">Faculty grade submission forms</li>
                  <li data-id="element-297">Batch upload capabilities</li>
                  <li data-id="element-298">Grade validation rules</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-299">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-300">
                  Academic Database
                </h4>
                <p className="text-sm text-gray-600" data-id="element-301">
                  <span className="font-medium" data-id="element-302">Tool:</span> Google Sheets with
                  protection
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-303">
                  <li data-id="element-304">Course-wise grade sheets</li>
                  <li data-id="element-305">Student performance tracking</li>
                  <li data-id="element-306">Attendance integration</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-307">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-308">
                  Result Publishing
                </h4>
                <p className="text-sm text-gray-600" data-id="element-309">
                  <span className="font-medium" data-id="element-310">Tool:</span> Apps Script +
                  Google Sites
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-311">
                  <li data-id="element-312">Automated marksheet generation</li>
                  <li data-id="element-313">Student portal integration</li>
                  <li data-id="element-314">Batch result analysis</li>
                </ul>
              </div>
            </div>
            <div className="mt-3 bg-yellow-50 p-3 rounded-lg" data-id="element-315">
              <h4 className="text-sm font-medium text-yellow-800" data-id="element-316">
                Grade Calculation Script
              </h4>
              <pre className="text-xs bg-gray-800 text-gray-100 p-2 rounded mt-2 overflow-x-auto" data-id="element-317">
                {`function calculateGrades() {
  var sheet = SpreadsheetApp.openById('YOUR_SHEET_ID').getSheetByName('CourseGrades');
  var data = sheet.getDataRange().getValues();
  // Skip header row
  for (var i = 1; i < data.length; i++) {
    var assignments = data[i][3]; // Column D: Assignments score
    var midterm = data[i][4];     // Column E: Midterm score
    var final = data[i][5];       // Column F: Final exam score
    var attendance = data[i][6];  // Column G: Attendance percentage
    // Calculate weighted total (example weights)
    var total = (assignments * 0.3) + (midterm * 0.3) + (final * 0.3) + (attendance * 0.1);
    // Assign letter grade
    var letterGrade;
    if (total >= 90) letterGrade = 'A';
    else if (total >= 80) letterGrade = 'B';
    else if (total >= 70) letterGrade = 'C';
    else if (total >= 60) letterGrade = 'D';
    else letterGrade = 'F';
    // Update sheet with calculated values
    sheet.getRange(i + 1, 8).setValue(total);        // Column H: Total score
    sheet.getRange(i + 1, 9).setValue(letterGrade);  // Column I: Letter grade
  }
  // Generate summary statistics
  var totalStudents = data.length - 1;
  var passed = 0;
  for (var i = 1; i < data.length; i++) {
    if (data[i][8] != 'F') passed++;
  }
  var passRate = (passed / totalStudents) * 100;
  Logger.log("Pass rate: " + passRate + "%");
  // Update summary sheet
  var summarySheet = SpreadsheetApp.openById('YOUR_SHEET_ID').getSheetByName('CourseSummary');
  summarySheet.getRange('B2').setValue(totalStudents);
  summarySheet.getRange('B3').setValue(passed);
  summarySheet.getRange('B4').setValue(passRate + "%");
}`}
              </pre>
            </div>
          </div>
          {/* Dashboard and Reporting */}
          <div data-id="element-318">
            <h3 className="text-lg font-medium text-gray-800 mb-3" data-id="element-319">
              5. Dashboard and Reporting
            </h3>
            <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-320">
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-321">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-322">
                  Admin Dashboards
                </h4>
                <p className="text-sm text-gray-600" data-id="element-323">
                  <span className="font-medium" data-id="element-324">Tool:</span> Google Data Studio
                  / Power BI
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-325">
                  <li data-id="element-326">Connect to all module spreadsheets</li>
                  <li data-id="element-327">Create real-time visualization dashboards</li>
                  <li data-id="element-328">Set up scheduled email reports</li>
                  <li data-id="element-329">Design role-specific views</li>
                </ul>
              </div>
              <div className="bg-gray-50 p-3 rounded-lg" data-id="element-330">
                <h4 className="font-medium text-gray-700 mb-2" data-id="element-331">
                  Integration with React App
                </h4>
                <p className="text-sm text-gray-600" data-id="element-332">
                  <span className="font-medium" data-id="element-333">Tool:</span> Google Sheets API /
                  Microsoft Graph API
                </p>
                <ul className="list-disc list-inside text-xs text-gray-500 mt-2" data-id="element-334">
                  <li data-id="element-335">Connect React frontend to spreadsheet data</li>
                  <li data-id="element-336">Implement OAuth authentication</li>
                  <li data-id="element-337">Create API middleware for data access</li>
                  <li data-id="element-338">Set up real-time data synchronization</li>
                </ul>
              </div>
            </div>
            <div className="mt-3 bg-yellow-50 p-3 rounded-lg" data-id="element-339">
              <h4 className="text-sm font-medium text-yellow-800" data-id="element-340">
                React-Sheets Integration Code
              </h4>
              <pre className="text-xs bg-gray-800 text-gray-100 p-2 rounded mt-2 overflow-x-auto" data-id="element-341">
                {`// Example React code to fetch data from Google Sheets API
import React, { useState, useEffect } from 'react';
const GoogleSheetsData = () => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const API_KEY = 'YOUR_API_KEY';
  const SHEET_ID = 'YOUR_SHEET_ID';
  const RANGE = 'Students!A2:F50'; // Adjust as needed
  useEffect(() => {
    const fetchData = async () => {
      try {
        const response = await fetch(
          \`https://sheets.googleapis.com/v4/spreadsheets/\${SHEET_ID}/values/\${RANGE}?key=\${API_KEY}\`
        );
        if (!response.ok) {
          throw new Error('Network response was not ok');
        }
        const result = await response.json();
        setData(result.values);
        setLoading(false);
      } catch (error) {
        setError(error);
        setLoading(false);
      }
    };
    fetchData();
  }, []);
  if (loading) return <div>Loading...</div>;
  if (error) return <div>Error: {error.message}</div>;
  return (
    <div>
      <h2>Student Data from Google Sheets</h2>
      <table>
        <thead>
          <tr>
            <th>ID</th>
            <th>Name</th>
            <th>Email</th>
            <th>Program</th>
            <th>Status</th>
          </tr>
        </thead>
        <tbody>
          {data.map((row, index) => (
            <tr key={index}>
              <td>{row[0]}</td>
              <td>{row[1]}</td>
              <td>{row[2]}</td>
              <td>{row[3]}</td>
              <td>{row[4]}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};
export default GoogleSheetsData;`}
              </pre>
            </div>
          </div>
        </div>
      </Card>
      {/* Security and Access Control */}
      <Card title="Security and Access Control" data-id="element-342">
        <div className="space-y-4" data-id="element-343">
          <p className="text-sm text-gray-700" data-id="element-344">
            Implementing proper security measures using built-in cloud tool
            capabilities:
          </p>
          <div className="grid grid-cols-1 md:grid-cols-2 gap-4" data-id="element-345">
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-346">
              <h3 className="font-medium text-gray-800 mb-2" data-id="element-347">
                Role-Based Access
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1" data-id="element-348">
                <li data-id="element-349">
                  <span className="font-medium" data-id="element-350">Students:</span> View-only
                  access to their own records
                </li>
                <li data-id="element-351">
                  <span className="font-medium" data-id="element-352">Faculty:</span> Edit access to
                  grades, view student profiles
                </li>
                <li data-id="element-353">
                  <span className="font-medium" data-id="element-354">Admin Staff:</span>{' '}
                  Department-specific edit access
                </li>
                <li data-id="element-355">
                  <span className="font-medium" data-id="element-356">System Admin:</span> Full access
                  to all modules
                </li>
              </ul>
              <div className="mt-3 text-xs text-gray-500" data-id="element-357">
                <p data-id="element-358">
                  Implementation: Use Google Workspace's granular sharing
                  permissions or Microsoft 365 security groups
                </p>
              </div>
            </div>
            <div className="border border-gray-200 rounded-lg p-4" data-id="element-359">
              <h3 className="font-medium text-gray-800 mb-2" data-id="element-360">
                Data Protection
              </h3>
              <ul className="list-disc list-inside text-sm text-gray-600 space-y-1" data-id="element-361">
                <li data-id="element-362">Automatic daily backups of all spreadsheets</li>
                <li data-id="element-363">Version history for tracking changes</li>
                <li data-id="element-364">Data validation to prevent corruption</li>
                <li data-id="element-365">Cell/range protection for sensitive information</li>
              </ul>
              <div className="mt-3 text-xs text-gray-500" data-id="element-366">
                <p data-id="element-367">
                  Implementation: Configure Google Drive backup settings or
                  OneDrive versioning policies
                </p>
              </div>
            </div>
          </div>
          <div className="bg-yellow-50 p-3 rounded-lg" data-id="element-368">
            <h4 className="text-sm font-medium text-yellow-800" data-id="element-369">
              Backup Automation Script
            </h4>
            <pre className="text-xs bg-gray-800 text-gray-100 p-2 rounded mt-2 overflow-x-auto" data-id="element-370">
              {`function createDailyBackup() {
  // Array of important spreadsheet IDs to backup
  var spreadsheetIds = [
    'YOUR_STUDENTS_SHEET_ID',
    'YOUR_FEES_SHEET_ID',
    'YOUR_HOSTEL_SHEET_ID',
    'YOUR_EXAMS_SHEET_ID'
  ];
  // Create backup folder with date
  var backupFolderName = "ERP_Backup_" + Utilities.formatDate(new Date(), "GMT", "yyyy-MM-dd");
  var parentFolder = DriveApp.getFolderById("YOUR_BACKUPS_FOLDER_ID");
  var backupFolder = parentFolder.createFolder(backupFolderName);
  // Copy each spreadsheet to the backup folder
  spreadsheetIds.forEach(function(id) {
    var file = DriveApp.getFileById(id);
    file.makeCopy(file.getName(), backupFolder);
  });
  // Log the backup
  Logger.log("Backup created in folder: " + backupFolderName);
  // Optional: Send email notification
  MailApp.sendEmail({
    to: "admin@college.edu",
    subject: "Daily ERP Backup Created",
    body: "The daily backup has been created in folder: " + backupFolderName
  });
}`}
            </pre>
          </div>
        </div>
      </Card>
      {/* Implementation Timeline */}
      <Card title="Implementation Timeline" data-id="element-371">
        <div className="space-y-4" data-id="element-372">
          <div className="relative" data-id="element-373">
            <div className="absolute inset-0 flex items-center" aria-hidden="true" data-id="element-374">
              <div className="w-full border-t border-gray-300" data-id="element-375"></div>
            </div>
            <div className="relative flex justify-between" data-id="element-376">
              <span className="bg-white px-3 text-sm font-medium text-gray-900" data-id="element-377">
                Week 1-2
              </span>
              <span className="bg-white px-3 text-sm font-medium text-gray-900" data-id="element-378">
                Week 3-4
              </span>
              <span className="bg-white px-3 text-sm font-medium text-gray-900" data-id="element-379">
                Week 5-6
              </span>
              <span className="bg-white px-3 text-sm font-medium text-gray-900" data-id="element-380">
                Week 7-8
              </span>
            </div>
          </div>
          <div className="grid grid-cols-1 md:grid-cols-4 gap-4 mt-4" data-id="element-381">
            <div className="border border-gray-200 rounded-lg p-3" data-id="element-382">
              <h4 className="text-sm font-medium text-indigo-700" data-id="element-383">
                Setup & Planning
              </h4>
              <ul className="list-disc list-inside text-xs text-gray-600 mt-2 space-y-1" data-id="element-384">
                <li data-id="element-385">Create G-Suite/Microsoft 365 accounts</li>
                <li data-id="element-386">Design spreadsheet database schema</li>
                <li data-id="element-387">Set up folder structure</li>
                <li data-id="element-388">Define access control policies</li>
              </ul>
            </div>
            <div className="border border-gray-200 rounded-lg p-3" data-id="element-389">
              <h4 className="text-sm font-medium text-indigo-700" data-id="element-390">
                Core Modules
              </h4>
              <ul className="list-disc list-inside text-xs text-gray-600 mt-2 space-y-1" data-id="element-391">
                <li data-id="element-392">Build admission forms</li>
                <li data-id="element-393">Create student database</li>
                <li data-id="element-394">Set up fee collection system</li>
                <li data-id="element-395">Configure email notifications</li>
              </ul>
            </div>
            <div className="border border-gray-200 rounded-lg p-3" data-id="element-396">
              <h4 className="text-sm font-medium text-indigo-700" data-id="element-397">
                Integration & Automation
              </h4>
              <ul className="list-disc list-inside text-xs text-gray-600 mt-2 space-y-1" data-id="element-398">
                <li data-id="element-399">Implement Apps Script/Power Automate flows</li>
                <li data-id="element-400">Connect modules to central database</li>
                <li data-id="element-401">Set up dashboard data sources</li>
                <li data-id="element-402">Create document templates</li>
              </ul>
            </div>
            <div className="border border-gray-200 rounded-lg p-3" data-id="element-403">
              <h4 className="text-sm font-medium text-indigo-700" data-id="element-404">
                Testing & Deployment
              </h4>
              <ul className="list-disc list-inside text-xs text-gray-600 mt-2 space-y-1" data-id="element-405">
                <li data-id="element-406">Staff training sessions</li>
                <li data-id="element-407">Pilot testing with sample data</li>
                <li data-id="element-408">System refinement based on feedback</li>
                <li data-id="element-409">Full deployment and monitoring</li>
              </ul>
            </div>
          </div>
        </div>
      </Card>
      {/* Cost Comparison */}
      <Card title="Cost Comparison: Cloud ERP vs Commercial Solutions" data-id="element-410">
        <div className="overflow-x-auto" data-id="element-411">
          <table className="min-w-full divide-y divide-gray-200" data-id="element-412">
            <thead className="bg-gray-50" data-id="element-413">
              <tr data-id="element-414">
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-415">
                  Component
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-416">
                  Cloud-Based Solution
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-417">
                  Commercial ERP
                </th>
                <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider" data-id="element-418">
                  Savings
                </th>
              </tr>
            </thead>
            <tbody className="bg-white divide-y divide-gray-200" data-id="element-419">
              <tr data-id="element-420">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-421">
                  Software Licensing
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-422">
                  $5-12 per user/month
                  <br data-id="element-423" />
                  <span className="text-xs text-gray-400" data-id="element-424">
                    (Google Workspace/Microsoft 365)
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-425">
                  $20,000-50,000 upfront
                  <br data-id="element-426" />
                  <span className="text-xs text-gray-400" data-id="element-427">
                    + annual maintenance
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-428">
                  95%+
                </td>
              </tr>
              <tr data-id="element-429">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-430">
                  Implementation
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-431">
                  1-2 months
                  <br data-id="element-432" />
                  <span className="text-xs text-gray-400" data-id="element-433">
                    Internal staff time
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-434">
                  6-12 months
                  <br data-id="element-435" />
                  <span className="text-xs text-gray-400" data-id="element-436">
                    $10,000-30,000 consulting
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-437">
                  80%+
                </td>
              </tr>
              <tr data-id="element-438">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-439">
                  Hardware Requirements
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-440">
                  Minimal
                  <br data-id="element-441" />
                  <span className="text-xs text-gray-400" data-id="element-442">
                    Standard computers with internet
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-443">
                  Significant
                  <br data-id="element-444" />
                  <span className="text-xs text-gray-400" data-id="element-445">
                    Servers, infrastructure, etc.
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-446">
                  90%+
                </td>
              </tr>
              <tr data-id="element-447">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-448">
                  Maintenance
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-449">
                  Included
                  <br data-id="element-450" />
                  <span className="text-xs text-gray-400" data-id="element-451">
                    Provider maintains platform
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-452">
                  $5,000-15,000 annually
                  <br data-id="element-453" />
                  <span className="text-xs text-gray-400" data-id="element-454">
                    Support contracts
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-455">
                  100%
                </td>
              </tr>
              <tr data-id="element-456">
                <td className="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900" data-id="element-457">
                  Training
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-458">
                  Minimal
                  <br data-id="element-459" />
                  <span className="text-xs text-gray-400" data-id="element-460">
                    Familiar interfaces
                  </span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-500" data-id="element-461">
                  Extensive
                  <br data-id="element-462" />
                  <span className="text-xs text-gray-400" data-id="element-463">$5,000-10,000</span>
                </td>
                <td className="px-6 py-4 whitespace-nowrap text-sm text-green-600" data-id="element-464">
                  85%+
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </Card>
    </div>;
};